import React from "react";
import { LeftArrow, RightArrow } from "../IconTheme";

export const NextSlide = () => {
	return (
		<div className="slide-next">
			<RightArrow />
		</div>
	);
};

export const PrevSlide = () => {
	return (
		<div className="slide-prev">
			<LeftArrow />
		</div>
	);
};
